export default "__VITE_ASSET__ef765026__"